import { FunctionComponent } from 'react';
import { V2SelectComponent } from '@terragotech/page-renderer';
import styled from 'styled-components';
import { NestedPageControlProps } from '../PageTypes';
import { StandardInputFrame, Label, LabelSubText } from './Common';
import { colors } from 'utils/colors';
import _ from 'lodash';
import { CustomPageBadges } from './CustomPageBadges';

const Placeholder = styled.div`
  font-size: 16px;
  line-height: 19px;
  text-align: left;
  color: ${colors.title};
  margin-right: 15px;
`;
const PlaceHolderFrame = styled.div`
  display: flex;
  margin-left: 15px;
  margin-bottom: 12px;
`;

const PastedMark = styled.div`
  position: absolute;
  margin: 5px;
  right: 0;
  bottom: 0;
  font-weight: 700;
  font-size: 12px;
`;
const SelectControl: FunctionComponent<NestedPageControlProps<V2SelectComponent>> = (
  props
) => {
  const { controlDefinition, pasted, isPageEditor } = props;
  const capitalizedControlType = _.upperFirst(controlDefinition.type);
  return (
    <StandardInputFrame>
      <Label
        text={controlDefinition.label}
        conditional={Boolean(controlDefinition.displayOptions)}
        isPageEditor={isPageEditor}
      />
      {isPageEditor && (
        <LabelSubText isDisplayOptionsEnabled={Boolean(controlDefinition.displayOptions)}>
          {capitalizedControlType}
        </LabelSubText>
      )}
      <PlaceHolderFrame>
        <Placeholder>{controlDefinition.options.type==='SimpleOption' ? controlDefinition.options.items[0]?.value : controlDefinition.options.type}</Placeholder>
      </PlaceHolderFrame>
      <CustomPageBadges controlDefinition={controlDefinition} />
      {pasted && <PastedMark>Pasted</PastedMark>}
    </StandardInputFrame>
  );
};
export default SelectControl;
